import { component } from 'picoapp';
import { clear } from 'utils/node';

export default component(async (node) => {
  const { sites } = window;

  const output = node.querySelector('[data-languages]');
  const trigger = node.querySelector('[data-trigger]');

  const renderFlag = (flag) => (`<span class="w-5 h-5">${flag}</span>`);

  const renderSite = (site) => {
    const {
      label,
      flag,
      url,
      prettyUrl,
    } = site;

    return String.raw`
      <a class="flex items-center space-x-2 px-3.5 py-2 border-b border-white/10 last:border-0" href="${prettyUrl ?? `https://${url}`}">
        ${renderFlag(flag)}
        <span>${label}</span>
      </a>
    `;
  };

  clear(output);

  const current = Object.values(sites).find((site) => site.locale === Shopify.locale);
  if (current) {
    const currentLanguage = node.querySelector('[data-current-language]');
    currentLanguage.textContent = current.label;
  }

  Object.values(sites)
    .filter((site) => site.locale !== Shopify.locale)
    .forEach((site) => {
      output.insertAdjacentHTML('beforeend', renderSite(site));
    });

  trigger.addEventListener('click', () => {
    node.classList.toggle('is-active');
  });

  document.addEventListener('click', (event) => {
    if (!node.contains(event.target)) {
      node.classList.remove('is-active');
    }
  });
});
